// iter87.258 — Official Premier League club brand color pairs. Keyed
// primarily by the SHORT form our `scheduled_matches.home_label` /
// `.away_label` fields actually store (verified against live DB rows —
// e.g. "Coventry" not "Coventry City", "Newcastle" not "Newcastle
// United", "Tottenham" not "Tottenham Hotspur", "Leeds" not "Leeds
// United", "Brighton" not "Brighton & Hove Albion", "Ipswich" not
// "Ipswich Town", "Bournemouth" not "AFC Bournemouth"). Long-form
// aliases included too so this stays correct if any other template
// ever stores the full club name instead.
//
// Note: Aston Villa's official hex values (Claret #670E36 / Sky Blue
// #7BB2DD) are used here — the source list had both colors duplicated
// to the same (incorrect) hex, which was corrected to the real values.
export const EPL_TEAM_COLORS = {
    "Bournemouth": ["#DA291C", "#000000"],
    "AFC Bournemouth": ["#DA291C", "#000000"],
    "Arsenal": ["#EF0107", "#FFFFFF"],
    "Aston Villa": ["#670E36", "#7BB2DD"],
    "Brentford": ["#E30613", "#FFFFFF"],
    "Brighton": ["#0057B8", "#FFFFFF"],
    "Brighton & Hove Albion": ["#0057B8", "#FFFFFF"],
    "Chelsea": ["#034694", "#FFFFFF"],
    "Coventry": ["#70B2E2", "#0B1F3F"],
    "Coventry City": ["#70B2E2", "#0B1F3F"],
    "Crystal Palace": ["#1B458F", "#C41230"],
    "Everton": ["#003399", "#FFFFFF"],
    "Fulham": ["#FFFFFF", "#000000"],
    "Hull City": ["#F5A623", "#000000"],
    "Ipswich": ["#0000FF", "#FFFFFF"],
    "Ipswich Town": ["#0000FF", "#FFFFFF"],
    "Leeds": ["#FFFFFF", "#0060A9"],
    "Leeds United": ["#FFFFFF", "#0060A9"],
    "Liverpool": ["#C8102E", "#FFFFFF"],
    "Manchester City": ["#6CABDD", "#FFFFFF"],
    "Manchester United": ["#DA020E", "#FFE500"],
    "Newcastle": ["#000000", "#FFFFFF"],
    "Newcastle United": ["#000000", "#FFFFFF"],
    "Nottingham Forest": ["#DD0000", "#FFFFFF"],
    "Sunderland": ["#EB172B", "#FFFFFF"],
    "Tottenham": ["#FFFFFF", "#131F53"],
    "Tottenham Hotspur": ["#FFFFFF", "#131F53"],
};

function hashColor(name) {
    let hash = 0;
    for (let i = 0; i < (name || "").length; i++) {
        hash = (hash * 31 + name.charCodeAt(i)) % 360;
    }
    return `hsl(${hash}, 55%, 38%)`;
}

// Returns [primary, secondary] — real brand pair when known, otherwise
// a deterministic single-hue fallback (both slots same color) so
// unmapped names (other leagues sharing this ticker) still render.
export function eplTeamColorPair(name) {
    return EPL_TEAM_COLORS[name] || [hashColor(name), hashColor(name)];
}
